import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as forge from 'node-forge'
import * as getPem from 'rsa-pem-from-mod-exp';
import * as RSAXML from 'rsa-xml';
import { parseString } from 'xml2js';

@Injectable()
export class CriptoService {


  constructor(private http: HttpClient) { }

  public criptografar(value: string) {

    //chamada do xml que possui a chave publica
    const promise = this.http.get(environment.chavePublica, { responseType: "text" }).toPromise();

    return promise.then(data => {
      let json = this.convertXmlToJson(data);
      return this.publicEncrypt(value, json);
    })
  }

  //converte o xml da chave para um objeto Json
  private convertXmlToJson(xml) {

    let json = '';
    parseString(xml, function (err, result) {
      json = result;
    });

    return json;
  }

  //recebe o valor a ser criprografado com o Json do Rsa
  private privateDecrypt(value, data) {

    let pem = new RSAXML().exportPemKey(data);
    const privateKey = forge.pki.privateKeyFromPem(pem);

    return privateKey.decrypt(Buffer.from(value, 'base64'));
  }

  //recebe o valor a ser criprografado com o Json do Rsa
  private publicEncrypt(value, json) {

    let modulus = json.RSAKeyValue.Modulus[0].toString();
    let exponent = json.RSAKeyValue.Exponent[0].toString();

    //converte o modulus/exponent da chave RSA em formato PEM
    let pem = getPem(modulus, exponent);

    //cria a chave publica
    const publicKey = forge.pki.publicKeyFromPem(pem);

    //tranforma em buffer o valor a ser criptografado
    const buffer = forge.util.createBuffer(value, 'utf-8');
    const bytes = buffer.getBytes();

    //criptografa utilizando o Public-Key Cryptography Standards
    const encrypted = publicKey.encrypt(bytes, 'RSAES-PKCS1-V1_5');

    //converte o valor criptografado em base64
    const b64Encoded = forge.util.encode64(encrypted);

    //converte o base64 do valor criptografado em encode URL
    return encodeURIComponent(b64Encoded);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/cripto.service.ts